<template>
    <!-- 燈箱：本人充分了解藉由網路線上服務之效力與本人親自辦理相同 -->
    <PopupBase v-model:visiblePopup="visible">
        <template #content>
            請問您是否同意透過「保險業通報作業資訊系統」篩選出您可能有投保且符合保全聯盟鏈轉送申請的公司。提醒您！篩選後所取得保險公司名單可能會受投保時間落差、投保內容認定而有差異，此功能也不代表已確認可以變更保單內容，您仍應再行檢視後進行刪除或增加，送出前請務必再次確認，或是與您投保的相關保險公司聯繫。
        </template>
        <template #action>
            <button
                class="btn btn-accent rounded-full"
                @click="handleClose"
            >
                不同意
            </button>
            <button
                class="btn gradient-primary rounded-full"
                @click="popupConfirm"
            >
                同意
            </button>
        </template>
    </PopupBase>
    <!-- 燈箱：公會無資料 -->
    <PopupBase v-model:visiblePopup="isPop">
        <template #content>
            {{ title }}
        </template>
        <template #action>
            <button
                class="btn gradient-primary rounded-full"
                @click="closePop"
            >
                了解並同意
            </button>
        </template>
    </PopupBase>
</template>
<script>
import { watchEffect, ref, reactive } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import PopupBase from '@/components/dialogs/Popup.vue';
import { getLiaCompany } from '@/apis/BCBD';
export default {
    components: {
        PopupBase
    },
    props: {
        visiblePopup: {
            type: Boolean,
            default: false,
        },
        showAllianceForm: {
            type: Boolean,
            default: false,
        },
        leaveRouteName: {
            type: String,
            default: '',
        },
        pupConfirm: {
            type: Boolean,
            default: false,
        }
    },
    emits: ['update:visiblePopup', 'update:showAllianceForm', 'update:pupConfirm', 'handleClose'],
    setup(props, { emit }) {
        const route = useRoute();
        const store = useStore();
        const { code } = route.meta;
        const companies = reactive({
            lifeCompany: [],
            propertyCompany: [],
            liaStatus: '',
        });
        const isPop = ref(false);
        const visible = ref(false);
        const showAlliance = ref(false);
        const pupConfirm = ref(false);
        const title = ref('');
        watchEffect(() => {
            visible.value = props.visiblePopup;
            showAlliance.value = props.showAllianceForm;
            pupConfirm.value = props.pupConfirm;
        });
        const handleClose = () => {
            visible.value = false;
            emit('update:visiblePopup', false);
            emit('update:showAllianceForm', true);
            emit('update:pupConfirm', false);
        };
        const popupConfirm = () => {
            getLiaCompany().then(res => {
                const { lifeCompany, propertyCompany, liaStatus } = res.data;
                companies.lifeCompany = lifeCompany;
                companies.propertyCompany = propertyCompany;
                companies.liaStatus = liaStatus;
                store.dispatch('services/setChangeItemsResult', { code, value: companies });

                if (liaStatus !== '0') {
                    if (liaStatus === 'N') {
                        title.value = '「查詢無以您為要保人投保有參與保全聯盟鏈之保險公司，請您勾選欲授權傳送變更資料之保險公司。」';
                        visible.value = false;
                        isPop.value = true;
                    } else if (liaStatus === 'F') {
                        title.value = '「保險業通報作業資訊系統」目前無法查詢，請您勾選欲授權傳送變更資料之保險公司。';
                        visible.value = false;
                        isPop.value = true;
                    }
                    visible.value = false;
                }

                emit('update:visiblePopup', false);
                emit('update:showAllianceForm', true);
                emit('update:pupConfirm', true);
            });
        };
        const closePop = () => {
            isPop.value = false;
        };
        return {
            title,
            isPop,
            visible,
            showAlliance,
            handleClose,
            closePop,
            popupConfirm
        };
    }
};
</script>
